import { connect } from "vuex-connect";
import { ActivationCodeApplyExistingContract } from "../../components";

export default connect({
  actionsToProps: {
    postApplyExistingContract: (dispatch, value) =>
      dispatch("activationCode/postApplyExistingContractForPaint", value)
  }
})(
  ActivationCodeApplyExistingContract.extendOptions.name + "-for-paint",
  ActivationCodeApplyExistingContract
);
